// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteConnectionPanel_content__nZvI6"};